<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">告警信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          form-style="width:30%"
          label-position="left"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">终端信息</span>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="editformref"
          :fields="editformfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          form-style="width:30%"
          label-position="left"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="lastformref"
          :fields="lastformfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          form-style="width:30%"
          label-position="left"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'Chongdianwendugaojingxiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      formfields: [
        {
          label: '告警原因',
          type: 'div',
          style: 'width:100%',
          prop: 'alarmName'
        },
        {
          label: '告警时间',
          type: 'div',
          style: 'width:100%',
          prop: 'createDate'
        },
        {
          label: '告警码',
          type: 'div',
          style: 'width:100%',
          prop: 'alarmCode'
        },
        {
          label: '异常值',
          type: 'div',
          style: 'width:100%',
          prop: 'actualValue'
        },
        {
          label: '告警来源',
          type: 'div',
          style: 'width:100%',
          prop: 'alarmSource'
        }
      ],
      formbefore: record => {
        console.log(record)
        return record
      },
      editformfields: [
        {
          label: '终端名称',
          type: 'div',
          style: 'width:100%',
          prop: 'connectorName'
        },
        {
          label: '终端编码',
          type: 'div',
          style: 'width:100%',
          prop: 'connectorID'
        },
        {
          label: '品牌型号',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentModel'
        },
        {
          label: '归属电站',
          type: 'div',
          style: 'width:100%',
          prop: 'stationName'
        },
        {
          label: '归属运营商',
          type: 'div',
          style: 'width:100%',
          prop: 'operatorName'
        }
      ],
      editformbefore: record => {
        console.log(record)
        return record
      },
      lastformfields: [
        {
          label: '充电单号',
          type: 'div',
          style: 'width:100%',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          type: 'div',
          style: 'width:100%',
          prop: 'loginName'
        },
        {
          label: '实时电度',
          type: 'div',
          style: 'width:100%',
          prop: 'electricDegree'
        },
        {
          label: '实时充电时长',
          type: 'div',
          style: 'width:100%',
          prop: 'duration'
        }
      ],
      lastformbefore: record => {
        console.log(record)
        return record
      },
      id: ''
    }
  },
  computed: {},
  mounted() {
    this.getDataDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/alarm/alarmRecord/getConnectorRecord',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp
          this.rowdata.duration = resp.duration + '分钟'
          this.rowdata.electricDegree = resp.electricDegree + '度'
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>



// WEBPACK FOOTER //
// src/views/alarmManagement/pileSafetyAlarmDetail.vue